import React from 'react'

import { Grid } from '@material-ui/core'

import PrimaryForm from './Form/PrimaryForm'
import AdditionalForm from './Form/AdditionalForm'
import GradeTable from './GradeTable/GradeTable'

const ModalBody = ({
  form,
  formInputChanged,
  additionalForm,
  additionalFormInputChanged,
  gradeLevelRows,
  gradeLevelRowInputChanged,
  percentError,
  translate
}) => {
  return (
    <Grid container direction={'column'} spacing={2}>
      <Grid container item justify={'space-evenly'} spacing={2}>
        <PrimaryForm form={form} formInputChanged={formInputChanged} />
      </Grid>
      <Grid container item xs>
        <AdditionalForm
          additionalForm={additionalForm}
          additionalFormInputChanged={additionalFormInputChanged}
        />
      </Grid>
      <Grid container item xs>
        <GradeTable
          gradeLevelRows={gradeLevelRows}
          gradeLevelRowInputChanged={gradeLevelRowInputChanged}
          percentError={percentError}
          translate={translate}
        />
      </Grid>
    </Grid>
  )
}

export default ModalBody
